module.exports = __webpack_public_path__ + "static/media/p4.1068dc9a.png";